import { createSlice } from "@reduxjs/toolkit";

export const gasSlice = createSlice({
    name: 'gas',
    initialState: {
        info: null,
        consumi: null,
        fatture: null,
        movimenti: null,
        saldo: null,
        datiPagamento: null,
        notifiche: null,
        payMethodDefault: null,
        popupInfo: null,
        rinnovoContrattualeGas: null,
    },
    reducers: {
        setRinnovoContrattuale: (state, action) => {
            state.rinnovoContrattualeGas = action.payload
        },
        setInfo: (state, action) => {
            state.info = action.payload
        },
        setInfoGas: (state, action) => {
            state.info = action.payload
        },
        setConsumi: (state, action) => {
            state.consumi = action.payload
        },
        setFatture: (state, action) => {
            state.fatture = action.payload
        },
        setMovimenti: (state, action) => {
            state.movimenti = action.payload
        },
        setSaldoGas: (state, action) => {
            state.saldo = action.payload
        },
        setDatiPagamentoGas: (state, action) => {
            state.datiPagamento = action.payload
        },
        setNotifiche: (state, action) => {
            state.notifiche = action.payload
        },
        setPayMethodDefault: (state, action) => {
            state.payMethodDefault = action.payload
        },
        setPopupInfo: (state, action) => {
            state.popupInfo = action.payload
        },
        setPopOff: (state, action) => {
            state.popupInfo.flag_popup = action.payload
        }
    }
});

export const { setPopOff, setRinnovoContrattuale, setPopupInfo, setPayMethodDefault, setNotifiche, setDatiPagamentoGas, setSaldoGas, setInfoGas, setMovimenti, setFatture, setInfo, setConsumi } = gasSlice.actions;

export const getInfoPopupGas = (state) => state.gas.popupInfo;

export const getContractTable = (state) => state.gas.rinnovoContrattualeGas;

export default gasSlice.reducer;